<template>
  <section
    v-if="status === 'success'"
    class="weatherforecast"
  >
    <SectionTitle
      :title="`${pointNameJa}の天気予報`"
      :left-text="localTimeLabel()"
      :share-title="pageTitle"
      share-category="POINT"
      is-h1
    />
    <div
      class="card"
    >
      <PointWxTableHour
        v-if="selectedTab === '1hour'"
        :table="data.hourly"
      />
      <PointWxTableToday
        v-if="selectedTab === 'today-tomorrow'"
        :table="data.todayTomorrow"
        @open-modal="$emit('open-modal')"
      />
      <PointWxTableWeek
        v-if="selectedTab === 'week'"
        :table="data.week"
        @open-modal="$emit('open-modal')"
      />
      <PointWxTableToggle
        v-model:selected="selectedTab"
        :list="toggleItems"
        form="square"
        :arrow="true"
      />
    </div>
  </section>
</template>

<script setup>
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { formatPointWeather } from '~/utils/pointWeatherFormatter'

dayjs.extend(utc)
dayjs.extend(timezone)

const props = defineProps({
  pointNameJa: {
    type: String,
    required: true
  },
  pointId: {
    type: String,
    required: true
  },
  now: {
    type: Number,
    required: true
  },
  pageTitle: {
    type: String,
    required: true
  }
})
defineEmits(['open-modal'])

const { data, status } = await useFetch(`/api/point/weather?pointId=${props.pointId}`, {
  transform: (data) => {
    return formatPointWeather(data[props.pointId], props.now)
  }
})

const localTimeLabel = () => {
  return `現地時刻 ${dayjs.unix(props.now).tz(data.value.timezone).locale(ja).format('M/D(ddd) H時')}`
}

const toggleItems = [
  {
    text: '1時間ごと',
    key: '1hour'
  },
  {
    text: '今日明日',
    key: 'today-tomorrow'
  },
  {
    text: '2週間天気',
    key: 'week'
  }
]

const selectedTab = ref(toggleItems[0].key)
</script>

<style lang="scss" scoped>
.weatherforecast {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .card {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 5px;
    border: solid 1px #dfe4f0;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .25);
    .toggle {
      margin-top: auto;
    }
  }
  @media screen and (min-width: 830px) {
  }
}
.main {
  .weatherforecast {
    @media screen and (min-width: 830px) {
    }
  }
}
</style>
